import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton, TextButtonClassNames } from '../../../../commons/buttons/TextButton';
import { UserSocialAccount } from '../SocialsSetting';

export const SocialItem: FC<UserSocialAccount> = ({
  label,
  icon,
  email,
  isConnected,
  handleUnlink,
  connectButton,
  type,
  unlinkMessage,
}) => {
  const { t } = useTranslation();

  return (
    <div className="account__social-accounts__items__item">
      <div className="account__social-accounts__items__item__icon-label">
        {icon}
        {email ? (
          <div className="account__social-accounts__items__item__icon-label__email-container">
            <p className="account__social-accounts__items__item__icon-label__email-container__label">
              {t('accountSettings.connectedAccount')}
            </p>
            <article className="account__social-accounts__items__item__icon-label__email-container__email">
              {email}
            </article>
          </div>
        ) : (
          <article className="account__social-accounts__items__item__icon-label">{label}</article>
        )}
      </div>
      {isConnected ? (
        <TextButton
          label={t('buttons.disable')}
          handleClick={() => handleUnlink(type, unlinkMessage)}
          className={TextButtonClassNames.Red}
        />
      ) : (
        connectButton
      )}
    </div>
  );
};
